module.exports = __webpack_public_path__ + "static/media/Fasad väst.e4b03b4e.JPG";